module.exports = __webpack_public_path__ + "img/logo-white.93a3e79b.svg";